export default __webpack_public_path__ + "static/media/4102580_applications_media_social_twitter_icon.f71ab9d1.png";